import { type CSSProperties } from 'typestyle/lib/types';

const navigationParentStyle = (open?: boolean): CSSProperties => ({
  paddingBottom: open ? 8 : 0,
});

export default navigationParentStyle;
